import LabelEstilo from '@/constants/LabelEstilo';
import i18n from '@/main';

const definirSituacao = codigo => {
    switch (codigo) {
        case 'PROCESSADO':
            return i18n.t('mensagens.laudos.processado');

        case 'EM_PROCESSAMENTO':
            return i18n.t('mensagens.laudos.emProcessamento');

        case 'FALHA_PROCESSAMENTO':
            return i18n.t('mensagens.laudos.falhaNoProcessamento');
        
        case 'NA_FILA':
            return i18n.t('mensagens.laudos.naFila');

        case 'CANCELADO':
            return i18n.t('mensagens.laudos.cancelado');
    
    }
};

const definirRenovabio = codigo => {
    switch (codigo) {
        case 'ELEGIVEL':
            return i18n.t('mensagens.laudos.elegivel');

        case 'NAO_ELEGIVEL':
            return i18n.t('mensagens.laudos.inelegivel');

        default:
            return '--';
    }
};

const definirEstilo = codigo => {
    switch (codigo) {
        case 'PROCESSADO':
        case 'ELEGIVEL':
            return LabelEstilo.VERDE;

        case 'EM_PROCESSAMENTO':
            return LabelEstilo.AMARELO;

        case 'FALHA_PROCESSAMENTO':
        case 'NAO_ELEGIVEL':
            return LabelEstilo.VERMELHO;

        case 'NA_FILA':
            return LabelEstilo.CINZA;

        case 'CANCELADO':
            return LabelEstilo.CANCELADO;
    
    }
};

const criarLegendaSituacao = completa => {

    let saida = [
        {
            estilo: LabelEstilo.AMARELO,
            texto: i18n.t('mensagens.laudos.emProcessamento')
        },
        {
            estilo: LabelEstilo.VERDE,
            texto: i18n.t('mensagens.laudos.processado')
        }
    ];

    if (completa) {
        saida.push({
            estilo: LabelEstilo.VERMELHO,
            texto: i18n.t('mensagens.laudos.falhaNoProcessamento')
        });
    }

    return saida;
};

const criarLegendaRenovabio = () => {
    return [
        {
            estilo: LabelEstilo.VERDE,
            texto: i18n.t('mensagens.laudos.elegivel')
        },
        {
            estilo: LabelEstilo.VERMELHO,
            texto: i18n.t('mensagens.laudos.inelegivel')
        }
    ];
};

export default {
    definirSituacao,
    definirRenovabio,
    definirEstilo,
    criarLegendaSituacao,
    criarLegendaRenovabio
};
